import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Box, Button } from '@mui/material'
import React from 'react'

const Paginator = ({
  previous,
  next,
  loading,
  totalRecords,
  recordsPerPage,
  maxVisibleButtons,
  page,
  setPage,
}) => {
  const totalPages = Math.ceil(totalRecords / recordsPerPage)

  const getVisibleButtons = () => {
    const half = Math.floor(maxVisibleButtons / 2)
    let start = Math.max(page - half, 1)
    let end = Math.min(start + maxVisibleButtons - 1, totalPages)

    if (end - start + 1 < maxVisibleButtons) {
      start = Math.max(end - maxVisibleButtons + 1, 1)
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
  }

  const visibleButtons = getVisibleButtons()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1em' }}>
      <Button
        disabled={loading || !previous}
        onClick={() => {
          setPage(page - 1)
        }}
        sx={{ px: 5, mt: 2, mx: 'auto', display: 'flex', margin: 'unset' }}
        variant='outlined'>
        <ArrowBackIosIcon />
      </Button>
      {visibleButtons.map(buttonPage => (
        <Button
          key={buttonPage}
          onClick={() => setPage(buttonPage)}
          style={{ fontWeight: buttonPage === page ? 'bold' : 'normal' }}>
          {buttonPage}
        </Button>
      ))}
      <Button
        disabled={loading || !next}
        onClick={() => {
          setPage(page + 1)
        }}
        sx={{ px: 5, mt: 2, mx: 'auto', display: 'flex', margin: 'unset' }}
        variant='outlined'>
        <ArrowForwardIosIcon />
      </Button>
    </Box>
  )
}
export default Paginator
